import {
    GET_AUTOMOBILE,
    REMOVE_AUTOMOBILE,
    GET_AUTOMOBILES,
    SET_AUTOMOBILE_DATA,
    SET_AUTOMOBILE_LOADING,
    REMOVE_AUTOMOBILE_LOADING,
    SET_AUTOMOBILE_VIN_LOADING,
    REMOVE_AUTOMOBILE_VIN_LOADING,
    SET_AUTOMOBILE_DROPDOWN,
    REMOVE_AUTOMOBILE_DROPDOWN,
    SET_AUTOMOBILE_OLD_VALUE,
    REMOVE_AUTOMOBILE_OLD_VALUE,
    SET_AUTOMOBILE_CONTACTS
} from "../../types";

const initialState = {
    loading: false, // Initit loading state
    automobileData: {},
    contacts: {},
    dropdowns: {},
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_AUTOMOBILE_VIN_LOADING:
        case SET_AUTOMOBILE_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_AUTOMOBILE_VIN_LOADING:
        case REMOVE_AUTOMOBILE_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_AUTOMOBILE_DROPDOWN:
            return {
                ...state,
                dropdowns: { ...payload }
            };
        case SET_AUTOMOBILE_CONTACTS:
            return {
                ...state,
                contacts: payload
            };
        case REMOVE_AUTOMOBILE_DROPDOWN:
            return {
                ...state,
                dropdowns: { ...payload }
            };
        case GET_AUTOMOBILES:
            return {
                ...state,
                ...payload
            };
        case GET_AUTOMOBILE:
            return {
                ...state,
                automobileData: { ...payload }
            };
        case REMOVE_AUTOMOBILE:
            return {
                ...state,
                automobileData: {}
            };
        case SET_AUTOMOBILE_DATA:
            return {
                ...state,
                automobileData: { ...payload }
            };
        case SET_AUTOMOBILE_OLD_VALUE:
            return {
                ...state,
                oldValue: payload
            };

        case REMOVE_AUTOMOBILE_OLD_VALUE:
            return {
                ...state,
                oldValue: ""
            };

        default:
            return state;
    }
}